// Packages
import { Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import LoadingIcon from "../components/LoadingIcon";
import { CaretLeft } from "@phosphor-icons/react";
// Actions
import { closeAlertMessage } from "../redux/ui";

const NavigationFooter = (props) => {
  const { type, saveData } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { shipping, information, payment, colors, urls } = useSelector(
    (state) => state.checkoutStore,
  );
  const { isLoading, doingRequest } = useSelector((state) => state.ui);
  const BillingFooter = (
    <div className="separatedContent col-12 mt-4">
      {!props.vertical && (
        <div className="col-6 small">
          {information.no_shipping_required ||
          information.shipping_option === "store_pickup" ? (
            <Link
              rel="noopener noreferrer"
              to={urls.information || "/#"}
              style={{ color: colors.main_color, textDecoration: "none" }}
              onClick={() => dispatch(closeAlertMessage())}
            >
              <CaretLeft className="fa-fw" size={24} weight="bold" />{" "}
              {t("shipping.back-to-information")}
            </Link>
          ) : (
            <Link
              rel="noopener noreferrer"
              to={urls.shipping || "/#"}
              style={{ color: colors.main_color, textDecoration: "none" }}
              onClick={() => dispatch(closeAlertMessage())}
            >
              <CaretLeft className="fa-fw" size={24} weight="bold" />{" "}
              {t("shipping.back-to-shipping")}
            </Link>
          )}
        </div>
      )}
      <div className={props.vertical ? "col-12" : "col-6"}>
        <button
          className="btn btn-primary py-3"
          onClick={saveData}
          disabled={!payment.payment_method_id || doingRequest || isLoading}
          id="save_place_order"
          style={
            props.vertical
              ? {
                  backgroundColor: colors.main_color,
                  color: colors.main_color_dark ? "white" : "black",
                  borderRadius: "8px",
                  fontWeight: "700",
                }
              : {
                  backgroundColor: colors.main_color,
                  color: colors.main_buttons_text_color,
                }
          }
        >
          <div
            style={
              props.vertical ? { fontSize: "19px", lineHeight: "23px" } : {}
            }
          >
            {doingRequest ? (
              <LoadingIcon isInsideButton={true} />
            ) : (
              t("information.place-order")
            )}
          </div>
        </button>
      </div>
    </div>
  );

  const InformationFooter = (
    <div className="col ms-auto text-end mt-4">
      <button
        className="btn btn-primary py-3"
        disabled={doingRequest}
        onClick={saveData}
        id={
          information.no_shipping_required ||
          information.shipping_option === "store_pickup"
            ? "save_go_to_payment"
            : information.shipping_option === "delivery"
              ? "save_go_to_shipping"
              : "save_select_local"
        }
        style={{
          width: "214px",
          backgroundColor: colors.main_color,
          color: colors.main_buttons_text_color,
        }}
      >
        <div style={{ fontSize: "16px", lineHeight: "23px" }}>
          {doingRequest ? (
            <LoadingIcon isInsideButton={true} />
          ) : information.no_shipping_required ||
            information.shipping_option === "store_pickup" ? (
            t("information.go-to-payment")
          ) : information.shipping_option === "delivery" ? (
            t("information.go-to-shipping")
          ) : (
            t("information.select-local")
          )}
        </div>
      </button>
    </div>
  );

  const ShippingFooter = (
    <div className="separatedContent col-12 mt-4">
      <div className="col-6">
        <Link
          rel="noopener noreferrer"
          to={urls.information || "/#"}
          style={{ color: colors.main_color, textDecoration: "none" }}
          className="small"
          onClick={() => dispatch(closeAlertMessage())}
        >
          <CaretLeft className="fa-fw" size={24} weight="bold" />{" "}
          {t("shipping.back-to-information")}
        </Link>
      </div>
      <div className="col-6">
        <button
          className="btn btn-primary py-3"
          onClick={saveData}
          id="save_go_to_payment"
          style={{
            backgroundColor: colors.main_color,
            color: colors.main_buttons_text_color,
          }}
          disabled={
            doingRequest ||
            (information.shipping_option === "delivery"
              ? (!shipping.shipping_ids.shipping_method_id &&
                  !shipping.shipping_ids.shipping_service_id) ||
                shipping.available === false
              : !shipping.pickup_point_id)
          }
        >
          <div style={{ fontSize: "19px", lineHeight: "23px" }}>
            {doingRequest ? (
              <LoadingIcon isInsideButton={true} />
            ) : (
              t("information.go-to-payment")
            )}
          </div>
        </button>
      </div>
    </div>
  );

  return (
    <Fragment>
      {(() => {
        switch (type) {
          case "information":
            return InformationFooter;
          case "shipping":
            return ShippingFooter;
          case "billingAndPayment":
            return BillingFooter;
        }
      })()}
    </Fragment>
  );
};
export default NavigationFooter;
